import React from 'react';
import ChartTest from '../components/ChartTest';

const ChartTestPage = () => {
    return (
        <div className="p-4">
            <h1 className="text-2xl font-bold mb-4">Chart Test Page</h1>
            <ChartTest />
        </div>
    );
};

export default ChartTestPage;
